import React, { useCallback, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import TasteOfGoldLearnMoreModal from './TasteOfGoldLearnMoreModal'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

interface Props {
  /**
   * 'full' — used in the LERE-off heroSection.subtitle (title is already campaign-specific)
   * 'subtitle-only' — used in the LERE-on override (prefixed with campaign name since title stays as "Top picks for you")
   */
  variant: 'full' | 'subtitle-only'
}

function TasteOfGoldHeroSubtitleContent(props: Props) {
  const { variant } = props
  const showModal = useContext(ModalContext)

  const openLearnMore = useCallback(() => {
    showModal(<TasteOfGoldLearnMoreModal />)
  }, [showModal])

  if (variant === 'subtitle-only') {
    return <FormattedMessage
      id="iCAW1lnm1k"
      defaultMessage="Experience {program} {tier} — Free airport transfer for international escapes. Limited time only. <link>Learn more</link>"
      description="Subtitle for Taste of Gold hero carousel with campaign name prefix"
      values={{
        program: getLoyaltyProgramDisplayName(),
        tier: getLoyaltyTierDisplayName('gold'),
        link: (chunks) => <TextLink wrap="no-wrap" weight="regular" onClick={openLearnMore}>{chunks}</TextLink>,
      }}
    />
  }

  return <FormattedMessage
    id="LjDCuEFnVQ"
    defaultMessage="Free airport transfer for your next international escape. Limited time only. <link>Learn more</link>"
    description="Subtitle for Taste of Gold hero section"
    values={{
      link: (chunks) => <TextLink wrap="no-wrap" weight="regular" onClick={openLearnMore}>{chunks}</TextLink>,
    }}
  />
}

export default TasteOfGoldHeroSubtitleContent
